import Vue from 'vue';
import Vuex from 'vuex';
import CommonModule from '@questelservices/common';
import UserModule from '@/modules/UserModule';
import NotificationModule from '@/modules/NotificationModule';
import ConfirmDialogModule from '@/modules/ConfirmDialogModule';
import FilterManagerModule from '@/modules/FilterManagerModule';
import createMutationsSharer from 'vuex-shared-mutations';
import createPersistedState from 'vuex-persistedstate';


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    CommonModule,
    UserModule: UserModule,
    NotificationModule: NotificationModule,
    FilterManagerModule: FilterManagerModule,
    ConfirmDialogModule,
  },
  state: {
      environment: process.env.NODE_ENV,
      useNewVersion: false,
  },
  //this is to handle when user logout with multiple browser tab open
  //it will sync vuex store state for authToken being cleared from other tab
  plugins: [
    createMutationsSharer({
      predicate: ["SET_AUTH_TOKEN"]
    }),
      createPersistedState({
          paths: ["FilterManagerModule"],
          storage: window.localStorage,
      })
  ]
});

export default store;
